export const RANGO_CONTAINER_ID = 'rango-container';
export const WIDGET_CONTAINER_ID = 'rango-swap-box';
export const EXPANDED_PANEL_ID = 'rango-expanded-box';
